import React, { useState } from 'react';
import PageHeader from "../../components/PageHeader";
import UpdateProfile from '../../components/profile/UpdateProfile';
import ChangePassword from '../../components/profile/ChangePassword';
import UpdateCompany from "../../components/profile/UpdateCompany";
import AlertList from "../../components/profile/AlertList";

const Index = () => {
    const [tab, setTab] = useState('edit-profile');

    return (
        <>
            <PageHeader name="Profile" />

            <div className="main-container container-fluid">
                {/* ROW-1 */}
                <div className="row">
                    {/* <div className="col-xxl-3 col-xl-4 col-lg-5 col-md-5">
                        <div className="card text-center shadow-none border profile-cover__img">
                            <div className="card-body">
                                <div className="profile-img-1">
                                    <img
                                        src="build/assets/images/users/18.jpg"
                                        alt="img"
                                        id="profile-img"
                                    />
                                    <a
                                        aria-label="anchor"
                                        href="#"
                                        className="rounded-pill avatar-icons bg-primary tx-fixed-white p-2"
                                    >
                                        <input
                                            type="file"
                                            name="photo"
                                            className="position-absolute w-100 h-100 op-0"
                                            id="profile-change"
                                        />
                                        <i className="fe fe-camera lh-base" />
                                    </a>
                                </div>
                                <div className="profile-img-content text-dark my-2">
                                    <div>
                                        <h5 className="mb-0">Cedric Kelly</h5>
                                        <p className="text-muted mb-0">UI Developer</p>
                                    </div>
                                </div>
                                <div>
                                    <div className="text-warning mb-0">
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star fs-20" />
                                        <i className="fa fa-star-half-o fs-20" />
                                    </div>
                                </div>
                                <p className="mb-2">(3145 Reviews)</p>
                                <div className="d-flex btn-list btn-list-icon justify-content-center">
                                    <button type="button" className="btn btn-sm btn-primary">
                                        <i className="fe fe-user-plus me-1" />
                                        Follow
                                    </button>
                                    <button type="button" className="btn btn-sm btn-info">
                                        <i className="fe fe-message-square me-1" />
                                        Message
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    <div className="col-xxl-12 col-xl-8 col-lg-7 col-md-7">
                        <div className="card">
                            <div className="card-header">
                                <ul className="nav nav-pills gap-2">
                                    <li className="nav-item">
                                        <button
                                            className={`nav-link ${tab === 'edit-profile' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setTab('edit-profile')}
                                        >
                                            Edit Profile
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${tab === 'company-info' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setTab('company-info')}
                                        >
                                            Company Info
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${tab === 'change-password' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setTab('change-password')}
                                        >
                                            Change Password
                                        </button>
                                    </li>
                                    <li className="nav-item" role="presentation">
                                        <button
                                            className={`nav-link ${tab === 'alerts' ? 'active' : ''}`}
                                            type="button"
                                            onClick={() => setTab('alerts')}
                                        >
                                            Alerts
                                        </button>
                                    </li>

                                </ul>
                            </div>
                            <div className="card-body p-0">
                                <div className="tab-content" id="pills-tabContent">
                                    {tab === 'edit-profile' && (
                                        <div className="tab-pane fade show active">
                                            <UpdateProfile isEdit={null} />
                                        </div>
                                    )}
                                    {tab === 'company-info' && (
                                        <div className="tab-pane fade show active">
                                            <UpdateCompany isEdit={null} />
                                        </div>
                                    )}

                                    {tab === 'change-password' && (
                                        <div className="tab-pane fade show active">
                                            <ChangePassword />
                                        </div>
                                    )}

                                    {tab === 'alerts' && (
                                        <div className="tab-pane fade show active">
                                            <AlertList />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ROW-1 CLOSED */}
            </div>

        </>
    );
};

export default Index;